/**
 * Выбирает русскую форму существительного для готовых UI-счётчиков.
 * Утилита не локализует число и не заменяет полноценную i18n pluralization.
 */

/** Возвращает число с одной из форм `one`, `few` или `many`. */
export function formatRussianCount(value, { one, few, many }) {
  const number = Math.abs(Number(value));
  const lastTwo = number % 100;
  const last = number % 10;

  let word = many;
  if (lastTwo < 11 || lastTwo > 14) {
    if (last === 1) word = one;
    else if (last >= 2 && last <= 4) word = few;
  }

  return `${number} ${word}`;
}
